/**
 * Company helpers. Code never compares company names (F5): the root company is the one without a parent, and a
 * company without an attached `company_logo` shows a text monogram of its abbreviation.
 */

/** True for the root of the company tree (empty or null `parent_company`). */
export function isRootCompany(c: { parent_company?: string | null }): boolean {
  return !c.parent_company;
}

/** Text chip for a company: its abbreviation in upper case, else the initials of its name. */
export function monogram(c: { name: string; abbr?: string | null }): string {
  const abbr = c.abbr?.trim();
  return abbr ? abbr.toUpperCase() : initials(c.name);
}

/** Initials for the fallback chip: "Demo World Logistics" → "DWL", "DEMO" → "DE". */
export function initials(company: string | null | undefined): string {
  if (!company) return "?";
  const words = company.split(/[\s.]+/).filter(Boolean);
  if (words.length >= 2) return words.slice(0, 3).map((w) => w[0]!.toUpperCase()).join("");
  return company.slice(0, 2).toUpperCase();
}

/** A warehouse/account name without its ERPNext company-abbreviation suffix (` - DRT`), whatever the company (F5). */
export function withoutCompanySuffix(name: string): string {
  return name.replace(/ - [A-Z0-9]+$/, "");
}
